import { render } from "./ExhibitionMatch.vue?vue&type=template&id=30db38ae&scoped=true"
import script from "./ExhibitionMatch.vue?vue&type=script&lang=js"
export * from "./ExhibitionMatch.vue?vue&type=script&lang=js"

import "./ExhibitionMatch.vue?vue&type=style&index=0&id=30db38ae&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30db38ae"]])

export default __exports__